import '../styles/Section.css';

function Section(props){
    const id = props.id;
    const children = props.children;
    console.log(props);
    return (
        <div className={`d-section ${props.negate === 1? 'invert':""}`} id={id}>
                {children}
        </div>
    );
}

export default Section;